import React, { useEffect, useState } from "react";
import PageTitle from "../../../module/pageTitle";
import AdminTable from "../../../Component/adminTable";
import LabelInput from "../../../Component/labelInput";
import { InputField, Submitbtn } from "../../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { deleteSellingSource, deleteTds, getSellingSourceList, getTdsList, updateSellingSource, updateTds } from "../publicationSlice";
import { validateFullName, startsWithSpace, validateIsDigitsAndDotOnly } from "../../../Utils/validators";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";

const EditTds = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const [isEdit, setIsEdit] = useState<Boolean>(false);
  const [tdsList, setTdsList] = useState<any>([]);
  const [tdsRate, setTdsRate] = useState<string>("");
  const [tdsName, setTdsName] = useState<string>("");
  const [tdsID, setTdsID] = useState<string>("");
  const [tdsStatus, setTdsStatus] = useState<string>("");
  useEffect(() => {
    getData()
  }, []);

  const getData = () => {
    dispatch(
      getTdsList({
        callback: (res: any) => {
          setTdsList(res?.data);
        },
        errorCallback: () => { },
      })
    );
  };

  const handleEdit = (value: any) => {
    setIsEdit(true);
    setTdsName(value?.name);
    setTdsRate(value?.rate);
    setTdsID(value?._id);
    setTdsStatus(value?.status);
  };

  const onChangeTDSName = (value: string) => {
    if (validateFullName(value) && !startsWithSpace(value)) {
      setTdsName(value);
    }

  };
  const onChangeTDSRate = (value: string) => {
    if (validateIsDigitsAndDotOnly(value)) {
      setTdsRate(value)
    }


  };
  const handleSubmit = (e: { preventDefault: () => void }) => {
    setIsEdit(true);
    e.preventDefault();
    const Payload = {
      name: tdsName,
      rate: tdsRate,
      status: tdsStatus,
    };
    dispatch(
      updateTds({
        id: tdsID,
        params: Payload,
        callback: (res: any) => {
          if (res?.status === "success") {
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              dispatch(hideSnackbar());
            }, 5000);
            setIsEdit(false);
            getData()
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
      })
    );
  };

  const handleDelete = (value: any) => {
    dispatch(
      deleteTds({
        id: value?._id,
        callback: (res: any) => {
          if (res?.data?.status === "success") {
            setIsEdit(false);
            dispatch(showSnackbar({ message: res?.data?.msg, type: res?.data?.status }));
            setTimeout(() => {
              dispatch(hideSnackbar());
              getData();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
      })
    );
  };
  const handleGoBack = () => {
    setIsEdit(false);
  };
  const renderTable = () => {
    return (
      <AdminTable
        tableData={tdsList ? tdsList : []}
        pagename={"tdsList"}
        tableHead={["S.N", "TDS Name", "TDS Rate", "Action"]}
        handleEdit={(value: any) => handleEdit(value)}
        handleDelete={(value: any) => handleDelete(value)}
        edit={true}
      />
    );
  };

  const renderEditMode = () => {
    return (
      <form onSubmit={handleSubmit}>
        <div className="row align-items-center">
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"TDS Name"} />
            <InputField
              key={"ex2"}
              placeholder={"Enter TDS Name"}
              setInputText={(value: any) => onChangeTDSName(value)}
              value={tdsName}
            />
          </div>
          <div className="col-md-4 mb-3">
            <LabelInput labelName={"TDS Rate"} />
            <InputField
              key={"ex2"}
              placeholder={"Enter TDS Rate"}
              setInputText={(value: any) => onChangeTDSRate(value)}
              value={tdsRate}
            />
          </div>
          <div className="col-md-2 mb-3 pt-4">
            <Submitbtn name={"Add TDS"} disabled={false} />
          </div>
        </div>
      </form>
    );
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Edit / Delete TDS"}
          breadCrumb={""}
          isEditMode={isEdit}
          setisEditMode={setIsEdit}
          cancelEdit={() => handleGoBack()}
        />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius">
          {isEdit ? renderEditMode() : renderTable()}
        </div>
      </div>
    </div>
  );
};

export default EditTds;
